import queryString from "query-string";

export const getProjectIdFromUrl = locationUrl => {
    return (locationUrl || "")
        .split("#")
        .map(location => {
            const searchStart = location.indexOf("?");
            const locationSearch = searchStart === -1 ? null : location.slice(searchStart);
            // Check query string
            const qs = queryString.parse(locationSearch);
            return qs.projectId || null;
        })
        .reduce((c, p) => (p ? p : c));
};

export default getProjectIdFromUrl;
